import * as React from 'react';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';

interface Division {
	id: string;
	name: string;
	seriesId: string;
	description: string;
}

interface DivisionsTabProps {
	seriesId: string;
	divisions: Division[];
	editingDivision: Division | null;
	isCreating: boolean;
	onStartCreate: () => void;
	onStartEdit: (division: Division) => void;
	onCancelEdit: () => void;
	onSave: () => void;
	onDelete: (division: Division) => void;
	onFieldChange: (field: keyof Division, value: any) => void;
}

export default class DivisionsTab extends React.Component<DivisionsTabProps> {
	render() {
		const { divisions, editingDivision, isCreating, onStartCreate, onStartEdit, onCancelEdit, onSave, onDelete, onFieldChange } = this.props;

		return (
			<div className="mt-3">
				<h4>Divisions</h4>
				<p className="text-muted">Organize classes into divisions for better management and results display.</p>
				
				<div className="mb-3">
					<Button className="btn btn-primary" onClick={onStartCreate}>
						Add New Division
					</Button>
				</div>

				<Modal show={!!editingDivision} onHide={onCancelEdit} centered>
					<Modal.Header closeButton>
						<Modal.Title>{isCreating ? 'Create New Division' : 'Edit Division'}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{editingDivision && (
							<>
								<div className="mb-3">
									<label htmlFor="divisionName" className="form-label">Name</label>
									<input 
										type="text" 
										id="divisionName" 
										className="form-control" 
										value={editingDivision.name} 
										onChange={(e) => onFieldChange('name', e.target.value)} 
										placeholder="e.g., Pro, Amateur, Youth"
									/>
								</div>
								<div className="mb-3">
									<label htmlFor="divisionDescription" className="form-label">Description</label>
									<textarea 
										id="divisionDescription" 
										className="form-control" 
										value={editingDivision.description || ''} 
										onChange={(e) => onFieldChange('description', e.target.value)} 
										rows={3}
										placeholder="Optional description of this division"
									/>
								</div>
							</>
						)}
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={onCancelEdit}>Cancel</Button>
						<Button variant="success" onClick={onSave}>
							{isCreating ? 'Create' : 'Save'}
						</Button>
					</Modal.Footer>
				</Modal>

				{divisions.length === 0 && !editingDivision && (
					<div className="alert alert-info">
						<strong>No divisions yet.</strong> Create divisions to organize your classes.
					</div>
				)}

				{divisions.length > 0 && (
					<table className="table table-striped">
						<thead>
							<tr>
								<th>Name</th>
								<th>Description</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{divisions.map(division =>
								<tr key={division.id}>
									<td><strong>{division.name}</strong></td>
									<td>{division.description || <span className="text-muted">No description</span>}</td>
									<td>
										<ButtonGroup>
											<Button className="btn btn-sm btn-primary" onClick={() => onStartEdit(division)}>Edit</Button>
											<Button className="btn btn-sm btn-danger" onClick={() => onDelete(division)}>Delete</Button>
										</ButtonGroup>
									</td>
								</tr>
							)}
						</tbody>
					</table>
				)}
			</div>
		);
	}
}
